"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditorFactory_1 = require("../EditorFactory");
const React = require("react");
const core_1 = require("@blueprintjs/core");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
class NumberEditorFactory extends EditorFactory_1.EditorFactory {
    getEditors(node, factory) {
        if (node.kind !== "primitive" || node.actualType.kind !== "number") {
            return [];
        }
        return [
            {
                isSingleLine: true,
                priority: 100,
                render: () => React.createElement(NumberEditor, { node: node })
            }
        ];
    }
}
exports.NumberEditorFactory = NumberEditorFactory;
let NumberEditor = class NumberEditor extends React.Component {
    handleInputChange(value) {
        this.props.node.value = value;
    }
    render() {
        const { node } = this.props;
        return (React.createElement("div", { className: "component-NumberEditor" },
            React.createElement(core_1.NumericInput, { value: node.value, onValueChange: this.handleInputChange })));
    }
};
__decorate([
    mobx_1.action.bound
], NumberEditor.prototype, "handleInputChange", null);
NumberEditor = __decorate([
    mobx_react_1.observer
], NumberEditor);
//# sourceMappingURL=NumberEditorFactory.js.map